import { Modal } from "react-bootstrap";

const closeButtonStyle = {
  minWidth: 96,
  border: "none",
  borderRadius: 6,
  background: "#dc3545",
  color: "#ffffff",
  fontWeight: 600,
  padding: "8px 22px",
};

const saveButtonStyle = {
  minWidth: 96,
  border: "none",
  borderRadius: 6,
  background: "#0d6efd",
  color: "#ffffff",
  fontWeight: 600,
  padding: "8px 22px",
};

const RouteMapModalFooter = ({
  onClose,
  onSave,
  saveLabel = "Save",
  saveDisabled = false,
}) => (
  <Modal.Footer className="justify-content-end border-0 pt-0 pb-3 pe-4 gap-2">
    <button type="button" onClick={onClose} style={closeButtonStyle} disabled={saveDisabled}>
      Close
    </button>
    <button
      type="button"
      onClick={onSave}
      style={{
        ...saveButtonStyle,
        opacity: saveDisabled ? 0.7 : 1,
        cursor: saveDisabled ? "not-allowed" : "pointer",
      }}
      disabled={saveDisabled}
    >
      {saveLabel}
    </button>
  </Modal.Footer>
);

export default RouteMapModalFooter;
